<div class="ig-side-bar bg-white h-full" role="complementary" aria-label="Sidebar navigation">
  <!-- <a *ngIf="!visitorPromotionImage.isDisabled&&visitorPromotionImage.image&&visitorPromotionImage.isTop"
       class="bottom-img"
       href="{{visitorPromotionImage.link}}"
       target="_blank"
       [attr.aria-label]="'Promotional banner'"
       [attr.aria-hidden]="true">
        <img [src]="imageService.safeImage(imageService.imageSourceUrl(visitorPromotionImage.image))" width="100%"
             alt="" role="presentation">
    </a> -->

  <div class="position-wrap relative" role="region" aria-label="Current view">
    <p class="sr-only">You are now viewing</p>
    <h1 class="text-2xl font-bold" aria-live="polite">{{command.isEventCalendar ? 'EVENTS' : 'PLACES'}}</h1>

    <button mat-icon-button
      class="!absolute right-3 top-6 !text-[32px] !w-8 !h-8 !p-0 !leading-6 flex justify-center items-center text-gray-500 !hidden mobile:!block"
      (click)="close()"
      aria-label="Close sidebar">
      <mat-icon aria-hidden="true" class="text-gray-600">chevron_left</mat-icon>
    </button>

    <!-- <button mat-icon-button
      class="!absolute -right-3 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow border border-gray-200 !hidden mobile:!hidden"
      aria-label="Collapse sidebar"
      (click)="onToggleCollapse()">
      <mat-icon class="text-gray-600">chevron_left</mat-icon>
    </button> -->
  </div>

  <nav class="sidebar-btn-wrap" aria-label="Navigation">
    <ig-search-field
      [value]="searchText"
      [label]="command.isEventCalendar ? 'SEARCH EVENTS' : 'SEARCH PLACES'"
      [formControl]="searchControl"
      class="block mb-[6px]"
      role="search">
    </ig-search-field>

    <div class="ig-sidebar-view-switcher mb-[6px]">
      <ig-accordion
        #viewSwitcher
        mode="dropdown"
        class="ig-sidebar-view-switcher-dropdown"
        [canItemClear]="false"
        [title]="'SELECT VIEW'"
        [menuClass]="'ig-sidebar-view-switcher-menu'"
        role="combobox"
        aria-haspopup="listbox">
        <ng-container dropdown>
          <div role="menu" aria-label="View options">
            <button
              mat-menu-item
              type="button"
              role="menuitemradio"
              (click)="selectSideBarMapView($event, viewSwitcher)"
              [attr.aria-checked]="command.isMapView">
              <span class="flex w-full items-center justify-between gap-3">
                <span>VIEW ON MAP</span>
                <mat-icon *ngIf="command.isMapView" class="!text-[18px] !w-[18px] !h-[18px] !m-0 !text-[#65a30d]">check</mat-icon>
              </span>
            </button>
            <button
              mat-menu-item
              type="button"
              role="menuitemradio"
              (click)="selectSideBarCardView($event, viewSwitcher)"
              [attr.aria-checked]="isCardViewActive">
              <span class="flex w-full items-center justify-between gap-3">
                <span>CARD VIEW</span>
                <mat-icon *ngIf="isCardViewActive" class="!text-[18px] !w-[18px] !h-[18px] !m-0 !text-[#65a30d]">check</mat-icon>
              </span>
            </button>
            <ng-container *ngIf="command.isEventCalendar">
              <button
                *ngIf="settings?.toggle?.calendarViewLayout"
                mat-menu-item
                type="button"
                role="menuitemradio"
                (click)="selectSideBarEventLayout($event, 'calendar', viewSwitcher)"
                [attr.aria-checked]="!command.isMapView && sideBarActiveEventLayoutStyle === 'calendar'">
                <span class="flex w-full items-center justify-between gap-3">
                  <span>CALENDAR VIEW</span>
                  <mat-icon *ngIf="!command.isMapView && sideBarActiveEventLayoutStyle === 'calendar'" class="!text-[18px] !w-[18px] !h-[18px] !m-0 !text-[#65a30d]">check</mat-icon>
                </span>
              </button>
              <button
                *ngIf="settings?.toggle?.calendarViewLayout"
                mat-menu-item
                type="button"
                role="menuitemradio"
                (click)="selectSideBarEventLayout($event, 'list', viewSwitcher)"
                [attr.aria-checked]="!command.isMapView && sideBarActiveEventLayoutStyle === 'list'">
                <span class="flex w-full items-center justify-between gap-3">
                  <span>LIST VIEW</span>
                  <mat-icon *ngIf="!command.isMapView && sideBarActiveEventLayoutStyle === 'list'" class="!text-[18px] !w-[18px] !h-[18px] !m-0 !text-[#65a30d]">check</mat-icon>
                </span>
              </button>
            </ng-container>
          </div>
        </ng-container>
      </ig-accordion>
    </div>

    <ng-container *ngIf="command.isEventCalendar&&isEventEnabled">
      <ig-event-date-filter
        class="mb-4"
        (dateSelected)="filterEventsByDate($event)"
        role="combobox"
        aria-haspopup="listbox">
      </ig-event-date-filter>

      <ig-event-location-filter
        *ngIf="settings.toggle.eventLocationFilter"
        class="mb-4"
        mode="expand"
        role="combobox"
        aria-haspopup="listbox">
      </ig-event-location-filter>

      <ig-favorite-custom-event-filter
        class="mb-4"
        (favSelected)="close()">
      </ig-favorite-custom-event-filter>

      <ig-button
        *ngIf="featuresToggle.manualEvents"
        icon="input"
        (trigger)="addEventsManually()"
        [ariaLabel]="'Submit your event'">
        <span class="text-sm tracking-normal xl:text-xs 2xl:text-sm" translate="no">SUBMIT YOUR EVENT</span>
      </ig-button>
    </ng-container>

    <ng-container *ngIf="!command.isEventCalendar&&isPlaceEnabled">

      <ig-custom-default-place-category-filter
        class="mb-3"
        [isOnlyShowNodeFromUrl]="true">
      </ig-custom-default-place-category-filter>
      <ig-favorite-custom-place-filter
        mode="expand"
        class="mb-4">
      </ig-favorite-custom-place-filter>
      <ig-place-location-filter
        *ngIf="settings.toggle.placeLocationFilter"
        class="mb-4"
        mode="expand">
      </ig-place-location-filter>

      <ig-button
        icon="input"
        (trigger)="addPlacesManually()"
        [ariaLabel]="'Submit your place'">
        <span class="notranslate tracking-normal" translate="no">Submit Your Place</span>
      </ig-button>
    </ng-container>

    @if (hubName === 'FultonCoNY') {
    <div class="!flex justify-between items-center mt-6 px-2">
      <ig-powered-by [style]="'iti-vertical'"></ig-powered-by>
      <img src="https://iti-images.s3.us-east-1.amazonaws.com/imgs/iloveny.png" alt=""
        class="!w-16 !h-16 translate-x-2">
    </div>
    } @else {
    <ig-powered-by [style]="'iti-horizontal'" class="mt-8"></ig-powered-by>
    }

  </nav>

  <!-- <a *ngIf="!visitorPromotionImage.isDisabled&&visitorPromotionImage.image&&!visitorPromotionImage.isTop"
        class="bottom-img" href="{{visitorPromotionImage.link}}" target="_blank">

        <img [src]="imageService.safeImage(imageService.imageSourceUrl(visitorPromotionImage.image))" width="100%"
            alt="promotional">
    </a> -->

</div>
